/* DO NOT MODIFY FILE, IT IS READ-ONLY. Make a merge request to the widget template to modify. */
import {validate} from 'uuid';
import type {Guid} from './Guid.js';

export const [tryParseGuid, parseGuid] = createParsers<string, Guid>(
	(v: string): v is Guid => isString(v) && validate(v),
	(value) => `${value} is invalid guid`
);

const isString = (value: unknown): value is string => typeof value === 'string';

function createParsers<TInput, TOutput extends TInput>(
	check: (value: TInput) => value is TOutput,
	getErrorMessage: (value: TInput) => string
): [(value: TInput) => TOutput | null, (value: TInput) => TOutput] {
	const parse = (value: TInput) => {
		if (check(value)) {
			return value;
		}

		throw Error(getErrorMessage(value));
	};

	const tryParse = (value: TInput): TOutput | null => (check(value) ? value : null);

	return [tryParse, parse];
}
